import { render } from "./DayOffReport.vue?vue&type=template&id=7f1e13c5"
import script from "./DayOffReport.vue?vue&type=script&lang=js"
export * from "./DayOffReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__